import { YieldFetcher } from '../../types'

const RSWETH_URL = 'https://v3-lst.svc.swellnetwork.io/api/tokens/sweth/apr'
const rsweth = 'Restaked Swell ETH::RSWETH'

export const rswethFetcher: YieldFetcher = {
  label: 'RSWETH',
  fetch: async () => {
    const res = await fetch(RSWETH_URL, {
      method: 'GET',
      headers: { Accept: 'application/json', 'User-Agent': '1delta/yields' },
    }).then((r) => r.text())
    return { [rsweth]: Number(res) ?? 0 }
  },
}
